<template>
  <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        clearable
        :label="label"
        prepend-inner-icon="mdi-calendar"
        readonly
        filled
        v-on="on"
        @click:clear="cleared"
        :value="formatDate(picker)"
        :disabled="disableInput"
      ></v-text-field>
    </template>
    <v-date-picker
      first-day-of-week="1"
      v-model="picker"
      no-title
      @input="dateMenu = false"
      :locale="currentUser.language_id"
    ></v-date-picker>
  </v-menu>
</template>

<script>
/**
 * @vue-prop {String} label - text label
 * @vue-prop {String} min - min date
 * @vue-prop {Boolean} disableInput - check if input is disabled
 * @vue-data {Boolean}[dateMenu=false] dateMenu - check if date picker is enabled
 * @vue-data {String} picker - values of the date picker
 * @vue-data {Boolean} rules - checks if field is required
 * @vue-event {String} formatDate(date) - format date in the right format
 * @vue-event {} cleared() - clear input from vuex store
 */

import moment from 'moment'

export default {
  name: 'custom-date-picker',
  props: {
    label: String,
    min: String,
    disableInput: Boolean,
    value: { type: [Number, String] },
    required: Boolean,
  },
  watch: {
    picker(value) {
      this.$emit('input', value)
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user
    },
  },
  data() {
    return {
      dateMenu: false,
      rules: {
        required: (value) => !!value || this.$t('Rules.required'),
      },
      picker: this.value == 999 ? null : this.value,
    }
  },
  methods: {
    formatDate(date) {
      return date ? moment(String(date)).format('DD.MM.YYYY') : ''
    },
    cleared() {
      this.$emit('input', '999')
    },
  },
}
</script>
